<div style="margin: 10px 0;">
  <div class="rte-holder" *ngIf="item.input_type==='textarea' && editor_options">
    <label>{{ item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}} <span *ngIf="item.required">*</span></label>
    <div class="rte-placeholder" [ngClass]="{'no-ui-placeholder':item.hide_editor_ui}" *ngIf="(!item.value || item.value==='') && !item.block_editor">{{item.translation_key_help||item.no_content_text || item.helpText || 'add_text_here'| translation|translationFromString | transformText :item?.text_transform_help}}</div>
    <div *ngIf="renderedService.isDisabled()" [innerHTML]="rte_value | safeHtml"></div>
    <editor (onActivate)="editorActive(true)" (onDeactivate)="editorActive(false)" [ngClass]="{'no-ui-editor':item.hide_editor_ui}" [height]="item.min_height" apiKey="test" [init]="editor_options"
            [(ngModel)]="rte_value" *ngIf="!checkDisable()"></editor>
  </div>


  <div *ngIf="item.input_type==='plaintextarea'">
    <div class="form-field">
      <label [for]="item.name">{{item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}}<span *ngIf="item.required">*</span></label><br>
      <textarea pTextarea [ngClass]="item.classes" [placeholder]="item.translation_key_placeholder||item.no_content_text || item.label| translation|translationFromString | transformText :item?.text_transform_placeholder" [(ngModel)]="rte_value" [name]="item.name" (input)="updateField($event)" [disabled]="checkDisable()" fluid></textarea>
    </div>
  </div>


  <div *ngIf="item.input_type!=='textarea' && item.input_type!=='plaintextarea'">
    <div class="form-field" [ngClass]="{'form-field-invalid':item.notvalid,'ng-invalid':this.item.notvalid}">
      <label [for]="item.name">{{item.translation_key_label||item.label| translation|translationFromString | transformText
        :item?.text_transform_label}}<span *ngIf="item.required">*</span></label>
      <p-inputgroup>
        <input (input)="updateField($event)" pInputText
          placeholder="{{item.required ? '* ' : ''}}{{item.translation_key_placeholder||item.no_content_text || item.label|translation}}"
          type="{{item.input_type}}" [(ngModel)]="item.value" [name]="item.name"
          [pattern]="item.input_type == 'number' ? '[-*0-9*\.0-9*]+' : item.validate" [step]="item.step || 0.01"
          [min]="item.min" [max]="item.max" [disabled]="checkDisable()" fluid />
        <p-inputgroup-addon *ngIf="item.helpText"
          [pTooltip]="translation_key_help||item.helpText| translation|translationFromString | transformText :item?.text_transform_help">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </p-inputgroup>
      <div style="color:red;" *ngIf="!isPristine&& item.input_type != 'number' && item.notvalid">
        {{item.translation_key_invalid||item.invalid||'content_invalid'| translation|translationFromString | transformText
        :item?.text_transform_invalid}}</div>
      <div style="color:red;" *ngIf="!isPristine&&item.input_type == 'number' && item.notvalid">
        {{'field_must_contain_number'| translation}}</div>
    </div>
  </div>
  </div>
